/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useRef } from 'react';
import '../../css/Login.css';
import ERPUtils from '../../helper/Utils';
import Loader from '../../helper/Loader';
import Popup from '../../helper/SuccessPopup';
import ApiGateway from '../../helper/ApiGateway';
import useStateCallback from '../../helper/asyncSetState';
import VerifyOtp from './verifyOtp';
import Warning from "../../images/warning.png";
import Correct from "../../images/correct.svg";
import Utils from '../../helper/Utils';
import { toast } from 'react-toastify';


const RegisterUser = (props) => {
	const { loginHere, close, setTokenEmployee } = props;
	const emailInputRef = useRef(null);
	//const confirmPasswordInputRef = useRef(null)

	const [details, setDetails] = useStateCallback({
		name: '',
		Email: '',
		password: '',
		confirmPassword: '',
		otp: '',
		clientId: '',
		isRegistered: true
	});
	const [LoaderActive, setLoaderActive] = useState(false);
	const [ErrorMsg, setErrorMsg] = useState('');
	const [ErrorPopup, setErrorPopup] = useState(false);
	const [RegSuccessPopup, setRegSuccessPopup] = useStateCallback(false);
	const [token, setToken] = useStateCallback(null);
	const SuccessIcon = <i className="fa fa-check successIcon" aria-hidden="true" />;
	const [emailVerifyMsg, setEmailVerifyMsg] = useState(null);
	const [ValidationError, setValidationError] = useStateCallback({
		EmailError: false,
		otpError: false
	});
	const [passwordMatchError, setPasswordMatchError] = useState(false);
	// required Fields:
	const [requiredFields, setRequiredFields] = useState({
		nameReqError: false,
		emailReqError: false,
		passwordReqError: false,
		otpReqError: false,
		confirmPasswordReqError: false
	});
	const [passwordError, setPasswordError] = useState(false);

	const [compState, setCompState] = useState({
		registerComp: true,
		otpComp: false
	});
	// enable or disable confirm password
	const [disableConfirmPassword, setDisableConfirmPassword] = useState(true);
	const [violetRule, setVioletRule] = useState({
		isSmallAndCap: false,
		isNumOrSpecial: false,
		valideLength: false
	})

	const StatusHandler = (name) => {
		var newobj = {};
		Object.keys(compState).map((el) => {
			if (el === name) {
				newobj[el] = true;
			} else {
				newobj[el] = false;
			}
			return '';
		});
		const convert = { ...newobj };
		setCompState(convert);
	};

	const validateEmail = (val) => {
		// eslint-disable-next-line
		if (!ERPUtils.isNullorWhiteSpace(val) && !ERPUtils.isNullOrEmpty(val)) {
			const EmailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			const validEmail = val === '' ? '' : val.match(EmailCheck);
			if (validEmail !== null) {
				ValidationErrorHandler("Email", false);
				checkUserEmailOnBlur();



			} else {
				setEmailVerifyMsg(null);
				ValidationErrorHandler("Email", true);
			}
		} else {
			ValidationErrorHandler("Email", false);


		}
	}

	const onChangeHandler = (event) => {
		let oldData = { ...details };
		let name = event.target.name;
		let val = event.target.value;
		if (name === 'Email') {
			oldData[name] = val?.trim();
		} else if (name === 'otp') {
			if (val.length > 6) {

				toast.error("Invalid OTP length or format");

			} else {
				oldData[name] = val;

			}

		} else if (name === 'password') {
			// oldData[name] = val?.trim();
			// passwordMeter(val);
			if (passwordError) {
				setPasswordError(false);
			}
			const passwordRegex = /^[a-zA-Z\d@$!^%*.?&#:]*$/;
			const isValidTest = passwordRegex.test(val)
			if (ERPUtils.isNullorWhiteSpace(val) || isValidTest) {
				oldData[name] = val;
			} else {
				toast.warn("Please enter accepted characters only", "warn")
			}
			oldData.confirmPassword = ""
		} else if (name === 'name') {
			let UpperCaseValue = String(val).toUpperCase();
			oldData[name] = UpperCaseValue;
		}
		else {
			oldData[name] = val;
		}

		if (ERPUtils.isNullorWhiteSpace(val) === false) {
			removeRequiredFields(name);
		}
		if (name === 'confirmPassword' && passwordMatchError) {
			setPasswordMatchError(false);
		}
		setDetails(oldData);
	};

	const ValidationErrorHandler = (name, removeError) => {
		let target = name;
		let comName = 'Error';
		let stateName = target + comName;
		if (removeError) {
			setValidationError({
				...ValidationError,
				[stateName]: true
			});
		} else {
			setValidationError({
				...ValidationError,
				[stateName]: false
			});
		}
	};

	const removeRequiredFields = (name) => {
		const oldData = { ...requiredFields };
		if (name === 'Email') {
			oldData['emailReqError'] = false;
		}
		if (name === 'password') {
			oldData['passwordReqError'] = false;
		}
		if (name === 'name') {
			oldData['nameReqError'] = false;
		}
		if (name === 'confirmPassword') {
			oldData['confirmPasswordReqError'] = false;
		}
		if (name === 'otp') {
			oldData['otpReqError'] = false;
		}
		setRequiredFields(oldData);
	};

	const CheckRequiredFields = (target) => {
		const oldData = { ...requiredFields };
		if (ERPUtils.isNullorWhiteSpace(details.name) && compState.registerComp) {
			oldData['nameReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.Email) && compState.registerComp) {
			oldData['emailReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.password) && compState.registerComp) {
			oldData['passwordReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.confirmPassword) && compState.registerComp) {
			oldData['confirmPasswordReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.otp) && compState.otpComp) {
			oldData['otpReqError'] = true;
		}
		checkForRequiredErrors(oldData, target);
	};

	const checkForRequiredErrors = (data, target) => {
		let validationErrorsFound = [];
		Object.keys(data).map((el) => {
			validationErrorsFound.push(data[el]);
			return '';
		});
		if (validationErrorsFound.indexOf(true) !== -1) {
			setRequiredFields(data);
		} else {
			if (target === 'email') {
				checkpassword();
			}
			if (target === 'otp') {
				RegisterHandler();
			}
			if (target === 'login') {
				checkUserEmail();
			}
		}
		return '';
	};

	const checkForValidationErrors = (target) => {
		const CheckValidationErrorsData = { ...ValidationError };
		let validationErrorsFound = [];
		setEmailVerifyMsg(null)
		Object.keys(CheckValidationErrorsData).map((el) => {
			validationErrorsFound.push(ValidationError[el]);
			return '';
		});
		// if (validationErrorsFound.indexOf(true) !== -1) {
		// 	setValidationAlert(true);
		// } else {
		CheckRequiredFields(target);
		// }
		return '';
	};

	const checkpassword = () => {
		const passwordCheck = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,100}$/;
		if (details.password.match(passwordCheck)) {
			setPasswordError(false);
			comparePasswords();
			// RegisterHandler();
		} else {
			setPasswordError(true);
		}
	};

	const comparePasswords = () => {
		if (details.password === details.confirmPassword) {
			checkUserEmail();
		} else {
			setPasswordMatchError(true);
			// setPassErrorPopup(true);
		}
	};

	const comparePaswordONBlur = () => {
		if (!ERPUtils.isNullorWhiteSpace(details.confirmPassword) && !ERPUtils.isNullOrEmpty(details.confirmPassword)) {
			if (details.password !== details.confirmPassword) {
				setPasswordMatchError(true);
			}
		}
	}

	// const closeReqFieldAlert = (name) => {
	// 	if (name === 'validationAlert') {
	// 		setValidationAlert(false);
	// 	}
	// 	if (name === 'password') {
	// 		setPassErrorPopup(false);
	// 	}
	// 	return '';
	// };

	// To alert the error popup:
	const AlertError = () => {
		setErrorPopup(true);
	};

	const ErrorPopupHandler = () => {
		setErrorPopup(!ErrorPopup);
	};

	const RegSuccessPopupHanlder = () => {
		setRegSuccessPopup(false, () => {
			// Local URl:
			// window.location.href = 'careers?token=' + encodeURIComponent(token) + '&';
			// Server URl:
			// window.location.href = '/index.html';
			// sessionStorage.setItem("_token_employee", token)
			setTokenEmployee(token)
			let state = { ...compState }
			state["otpComp"] = false
			setCompState(state);
			setTimeout(() => {
				loginHere("login")
			}, 50)
			close("", true);
		});

	};

	const checkUserEmail = () => {
		var data = {
			name: details.name,
			email: details.Email,
			password: details.password,
			clientId: details.clientId
		};
		setLoaderActive(true);
		ApiGateway.post('ApplicantSecurity/verifyRegisterApplicant', data, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response.data) === false) {
					if (response.data.success === true) {
						StatusHandler('otpComp');
					} else {
						if (response.data.failureMessage !== null) {
							setErrorMsg(response.data.failureMessage);
							AlertError();
						} else {
							setErrorMsg('An Error! occurred, Please try again');
							AlertError();
						}
					}
				} else {
					setErrorMsg('An Error! occurred, Please try again');
					AlertError();
				}
			} catch (ex) {
				setLoaderActive(false);
			} finally {
				setLoaderActive(false);
			}
		}, "Public");
	};


	const checkUserEmailOnBlur = () => {
		var data = {
			name: details.name,
			email: details.Email,
			password: details.password,
		};
		setLoaderActive(true);
		ApiGateway.post('ApplicantSecurity/verifyRegisterApplicantEmail?isForRegister=' + true, data, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response.data) === false) {
					if (response.data.success === true) {
						setEmailVerifyMsg(null);
						emailInputRef.current.focus()
					} else {
						if (response.data.failureMessage !== null) {
							setEmailVerifyMsg(response.data.failureMessage);
						} else {
							setEmailVerifyMsg("An error occurred. Couldn't verify the email");
						}
					}
				} else {
					setEmailVerifyMsg("An error occurred. Couldn't verify the email");
				}
			} catch (ex) {
				setLoaderActive(false);
			} finally {
				setLoaderActive(false);
			}
		}, "Public");
	};


	// Api call:
	const RegisterHandler = () => {
		var data = {
			name: details.name,
			email: details.Email,
			password: details.password,
			otp: details.otp,
			clientId: details.clientId
		};

		setLoaderActive(true);
		ApiGateway.post('ApplicantSecurity/RegisterApplicant', data, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response?.data) === false) {
					if (response.data?.success === true) {
						setRegSuccessPopup(true);
						// sessionStorage.setItem('RegistrationId', response.data.dto.empApplicationRegistrationId);
						// sessionStorage.setItem('ApplicantName', data.name);
						// sessionStorage.setItem('email', data.email);
						// setToken(response.data.dto.token, () => {
						// 	sessionStorage.setItem('token', response.data.dto.token)
						// 	loginHere("login")
						// });
					} else {
						if (response.data?.failureMessage !== null) {
							setErrorMsg(response.data?.failureMessage);
							AlertError();
						} else {
							setErrorMsg('An Error! occurred, Please try again');
							AlertError();
						}
					}
				} else {
					setErrorMsg('An Error! occurred, Please try again');
					AlertError();
				}
			} catch (ex) {
				setLoaderActive(false);
			} finally {
				setLoaderActive(false);
			}
		}, "Public");
	};

	const showPassWord = (name, target) => {
		var temp = document.getElementById(target);
		if (temp.type === 'password') {
			temp.type = 'text';
			document.getElementById(name).classList.add('fa-eye-slash');
		} else {
			temp.type = 'password';
			document.getElementById(name).classList.remove('fa-eye-slash');
		}
	};

	const checkCaseOfString = (string) => {
		const
			upper = /[A-Z]/.test(string),
			lower = /[a-z]/.test(string);

		return upper && lower;
	}
	const checkCaseOfNum = (string) => {
		const
			number = /[0-9]/.test(string),
			specialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(string);

		return number && specialChar;
	}

	const validatePassword = (string) => {

		const isCapitalAndSmallRule = checkCaseOfString(string);
		const isValidNumOrSpecialCase = checkCaseOfNum(string);
		const validLength = string.length > 8;
		const ruleErrorsObj = { ...violetRule }

		if (isCapitalAndSmallRule && isValidNumOrSpecialCase && validLength) {
			setDisableConfirmPassword(false)
			ruleErrorsObj["isSmallAndCap"] = false
			ruleErrorsObj["isNumOrSpecial"] = false
			ruleErrorsObj["valideLength"] = false


		} else {
			setDisableConfirmPassword(true);
			if (!isCapitalAndSmallRule) ruleErrorsObj["isSmallAndCap"] = true;
			else ruleErrorsObj["isSmallAndCap"] = false;
			if (!isValidNumOrSpecialCase) ruleErrorsObj["isNumOrSpecial"] = true;
			else ruleErrorsObj["isNumOrSpecial"] = false;
			if (!validLength) ruleErrorsObj["valideLength"] = true;
			else ruleErrorsObj["valideLength"] = false;

		}
		setVioletRule(ruleErrorsObj);
	}

	useEffect(() => {
		const getclientId = Utils.getUniqueID();
		sessionStorage.setItem("clientId", getclientId);
		let client = { ...details }
		client.clientId = getclientId
		setDetails(client)
	}, []);

	return (
		<div>
			<style>
				{`  input::-ms-reveal,
      input::-ms-clear {
        display: none;
      }`}
			</style>
			{compState.otpComp ? (
				<VerifyOtp
					onChangeHandler={onChangeHandler}
					close={close}
					ValidationError={ValidationError}
					CheckRequiredFields={CheckRequiredFields}
					RegisterHandler={RegisterHandler}
					requiredFields={requiredFields}
					details={details}
				/>
			) : null}

			{compState.registerComp ? (
				<div className="card employee-application-card-style-1">
					<div>
						<form action='none' onSubmit={(e) => { e.preventDefault() }}>
							<div className="formHeader">
								<h2 className="headTypo">
									Registration
									<button type="button" className="removeButton" onClick={close}>
										&times;
									</button>
								</h2>
							</div>
							<div className="formBody">
								<div className="form-group has-feedback formWrapper">
									<label className="formlabel">
										Name
									</label>
									<span className="loginsRequiredText">*</span>
									<input
										className="form-control input"
										onChange={onChangeHandler}
										name="name"
										type="text"
										placeholder="Name"
										autoComplete="off"
										value={details.name}
										onKeyDown={ERPUtils.validateName}
										maxLength={100}
									/>
									{requiredFields.nameReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter your name
										</p>
									) : null}
								</div>
								<div className="form-group has-feedback formWrapper" >
									<label className="formlabel">
										Email
									</label>
									<span className="loginsRequiredText">*</span>
									<input
										className="form-control input"
										onChange={onChangeHandler}
										name="Email"
										type="text"
										autoComplete="off"
										placeholder="Email Address"
										value={details.Email}
										onBlur={() => validateEmail(details.Email)}
										tabIndex={0}
										maxLength={200}
									/>
									<span toggle="#password-field" className="far fa-user field-icon" id="userIcon"></span>
									{requiredFields.emailReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter your email address
										</p>
									) : null}
									{Utils.isNullorWhiteSpace(emailVerifyMsg) ? "" :
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />{emailVerifyMsg}
										</p>
									}
									{ValidationError.EmailError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter  valid email address
										</p>
									) : null}
								</div>
								<div className="form-group has-feedback formWrapper" >
									<label className="formlabel">
										Password
									</label>
									<span className="loginsRequiredText">*</span>
									<input
										className="form-control input"
										name="password"
										type="password"
										onChange={onChangeHandler}
										placeholder="Password"
										autoComplete="off"
										value={details.password}
										id="registerPassword"
										onCopy={(e) => e.preventDefault()}
										onBlur={() => validatePassword(details.password)}
										tabIndex={0}
										ref={emailInputRef}
										maxLength={100}
										onKeyDown={(e) => {
											if ((e.key === "Tab" || e.key === 9))
												validatePassword(details.password)
										}}

									/>
									{!ERPUtils.isNullorWhiteSpace(details.password) &&
										<span
											className="fa fa-eye field-icon"
											id="registerPassCode"
											onClick={showPassWord.bind(this, 'registerPassCode', 'registerPassword')}
										/>
									}
									{requiredFields.passwordReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please enter your password
										</p>
									) : null}
									{/* rule here  */}
									<p className='px-2  m-0'>
										{checkCaseOfString(details.password) ?
											<img src={Correct} alt="correct" width="15" height="15" />
											: <img src={Warning} alt="warning" width="15" height="15" />
										}
										<span className='pl-1'
											style={{ fontSize: "12px", color: (violetRule.isSmallAndCap && !checkCaseOfString(details.password)) ? "red" : "inherit" }}
										>
											Includes both Capital and Small Letters</span>
									</p>
									<p className='px-2  m-0'>
										{checkCaseOfNum(details.password) ?
											<img src={Correct} alt="correct" width="15" height="15" />
											: <img src={Warning} alt="warning" width="15" height="15" />
										}
										<span className='pl-1'
											style={{ fontSize: "12px", color: (violetRule.isNumOrSpecial && !checkCaseOfNum(details.password)) ? "red" : "inherit" }}
										>
											Includes Numerical and Special characters (Accepted : @ $ ^ ! % * . ? & #)</span>
									</p>
									<p className='px-2  m-0'>
										{details.password?.length > 8 ?
											<img src={Correct} alt="correct" width="15" height="15" />
											: <img src={Warning} alt="warning" width="15" height="15" />
										}
										<span className='pl-1'
											style={{ fontSize: "12px", color: (violetRule.valideLength && !(details.password?.length > 8)) ? "red" : "inherit" }}
										>Includes more than 8 characters</span>
									</p>
								</div>
								<div className="form-group has-feedback formWrapper">
									<label className="formlabel">
										Confirm Password
									</label>
									<span className="loginsRequiredText">*</span>
									<input
										className="form-control input"
										name="confirmPassword"
										type="password"
										onChange={onChangeHandler}
										placeholder="Password"
										autoComplete="off"
										onCopy={(e) => e.preventDefault()}
										onPaste={(e) => {
											e.preventDefault();
										}}
										value={details.confirmPassword}
										id="registerConfirmPassword"
										disabled={disableConfirmPassword}
										onBlur={comparePaswordONBlur}
										tabIndex={0}
										maxLength={100}
									//ref={confirmPasswordInputRef}
									/>
									<span
										className="fa fa-eye field-icon"
										id="registerConfirmPassCode"
										onClick={showPassWord.bind(
											this,
											'registerConfirmPassCode',
											'registerConfirmPassword'
										)}
									/>
									{requiredFields.confirmPasswordReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Please confirm your password
										</p>
									) : null}
									{passwordMatchError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" /> Passwords are not matching
										</p>
									) : null}
								</div>
							</div>

							<div className="formFooter">
								<button className="ContinueButton" onClick={checkForValidationErrors.bind(this, 'email')}>
									Register
								</button>
								<span className="span">
									<br />
									<p name="login" className="link emp-appl-custom-link" onClick={() => loginHere("login")} tabIndex={0}
										onKeyDown={(e) => {
											if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
												loginHere("login")
										}}>
										Login Here
									</p>
								</span>
							</div>
						</form>
					</div>
				</div>
			) : null}
			{ErrorPopup ? (
				<Popup
					open={ErrorPopup}
					close={ErrorPopupHandler}
					msg={ErrorMsg}
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					title="Sorry!"
					success={false}
				/>
			) : null}
			{RegSuccessPopup ? (
				<Popup
					open={RegSuccessPopup}
					close={RegSuccessPopupHanlder}
					msg="Your account has been successfully created."
					icon={SuccessIcon}
					title="Success!"
					success={true}
				/>
			) : null}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			{/* {ValidationAlert ? (
				<Popup
					open={ValidationAlert}
					close={closeReqFieldAlert}
					msg="You have invalid error fields in your form"
					title="Sorry!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please review you form and submit"
					tabName="validationAlert"
				/>
			) : null} */}
			{/* {passErrorPopup ? (
				<Popup
					open={passErrorPopup}
					close={closeReqFieldAlert}
					msg="Please make sure that your new password and confirm password matches."
					title="Error!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please review you form and submit"
					tabName="password"
				/>
			) : null} */}
		</div>
	);
};

export default RegisterUser;
